import { useEffect, useRef, useState } from 'react';
import { Config } from 'src/config';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import CustomDomainRedirectIframe from '../customDomainIframe';
import TiktokAuthorizationModal from './tiktokAuthorization.Modal';
import { useResellerLimitDialog } from 'src/components/reseller-limit-context/resellerLimitContext';

const TiktokIntegration = (props) => {
  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const { showToast } = useToaster();
  const isCustomDomain = CommonHelper.CustomDomain();
  let intervalId = null;
  let isProcessing = false;
  const { showResellerLimitDialog } = useResellerLimitDialog();
  const messageListenerRef = useRef(null);

  useEffect(() => {
    intervalId = setInterval(() => {
      checkAccessTokenReceivedFromTiktok();
    }, Config.Common.socialAccountsIntegrationInterval);
    return () => {
      clearInterval(intervalId);
      cleanupListener();
    };
  }, []);

  const getTiktokOauthToken = () => {
    let url = `${Config.Tiktok.authorizeUrl}?client_key=${Config.Tiktok.clientId}&scope=${Config.Tiktok.scope}&response_type=${Config.Tiktok.responseType}&redirect_uri=${Config.Tiktok.redirectUri}&state=123456`;
    window.open(url, '_blank');
  };

  const cleanupListener = () => {
    if (messageListenerRef.current) {
      window.removeEventListener('message', messageListenerRef.current, false);
      messageListenerRef.current = null; // Reset the ref
    }
  };

  const checkAccessTokenReceivedFromTiktok = () => {
    if (isCustomDomain) {
      const handleMessage = (event) => {
        const { type, code } = event.data;
        if (type === 'tiktok_auth_code' && code && !isProcessing) {
          isProcessing = true;
          cleanupListener(); // Remove event listener
          clearInterval(intervalId); // Stop polling
          sendAccessTokenToServer(code); // Process the code
        }
      };

      if (!messageListenerRef.current) {
        window.addEventListener('message', handleMessage, false);
        messageListenerRef.current = handleMessage; // Save the reference
      }
    } else {
      var token = localStorage.getItem('tiktok_auth_code');
      var error = localStorage.getItem('tiktok_signin_error');
      if (token) {
        localStorage.removeItem('tiktok_auth_code');
        clearInterval(intervalId);
        sendAccessTokenToServer(token);
      } else if (error) {
        localStorage.removeItem('tiktok_signin_error');
        clearInterval(intervalId);
        showToast(error, 'e');
        handleClose();
      }
    }
  };
  const tiktokSuccessCallback = (data, message) => {
    CommonHelper.EnsureConversionFactorFlag(CommonHelper.ConversionFlagList.FIRST_SOCIAL_ACCOUNT_CONNECTED,"TIKTOK")
    showToast(message, 's');
    handleClose();
  };
  const tiktokFailureCallback = (message) => {
    if (!showResellerLimitDialog(message)) {
      message && showToast(message, 'e');
    }
    handleClose();
  };
  const sendAccessTokenToServer = (code) => {
    let TiktokForm = {
      code,
    };
    let postProps = {
      url: integrateModuleURL.sendTiktokAccessToken,
      body: TiktokForm,
      successCallback: tiktokSuccessCallback,
      failureCallback: tiktokFailureCallback,
    };
    HttpServices.Post(postProps);
  };

  const handleClose = () => {
    props.handleClose();
    cleanupListener();
  };

  return (
    <>
      {isAuthorizationModalOpen && (
        <TiktokAuthorizationModal handleConnectTiktok={getTiktokOauthToken} handleClose={handleClose} />
      )}
      {isCustomDomain && <CustomDomainRedirectIframe serviceName="tiktok" />}
    </>
  );
};
export default TiktokIntegration;
